export type GetProductPointsRulesResponseType = {
  points: number;
  multiply: boolean;
};
